import React from 'react';
import { Image } from 'semantic-ui-react';

const a11yButtonStyle = {
  width: '1px',
  height: '1px',
  fontSize: '1px',
  border: 'none',
  padding: '0',
  margin: '0',
  opacity: '0'
}

const Speaker = props => (
  <div className="speaker" onClick={() => props.showModal(props.speaker)}>
    <button style={a11yButtonStyle} onClick={() => props.showModal(props.speaker)} >Show More Details for {props.speaker.name}</button>
    <Image
      alt={props.speaker.name}
      className="speaker__image"
      src={props.speaker.picture}
    />
    <div className="speaker__name">
      <h3>{props.speaker.name}</h3>
      <p />
    </div>
    <div className="speaker__image-overlay">
      <div className="speaker__image-overlay-innerbox">
        <p className="speaker__title">{props.speaker.title}</p>
        <p className="speaker__institution">{props.speaker.institution}</p>
      </div>
    </div>
  </div>
);
export default Speaker;



// WEBPACK FOOTER //
// ./src/components/speaker.js